import { Selector } from "react-redux";

import { IAppState } from "@multiweb/types/react";
import { ApplicationTheme } from "@multiweb/uiShared/ApplicationTheme";
import { ThemeState } from "./types";

/**
 * Získá z globálního stavu podstrom patřící theme modulu.
 * @param state
 */
const getModel: Selector<IAppState, ThemeState> = (state) => state.core.theme;

/**
 * Získá název aktuálně nastaveného tématu aplikace.
 */
export const getTheme: Selector<IAppState, ApplicationTheme> = (state) => getModel(state);

/**
 * Vrátí příznak, jestli je aktuální téma aplikace nastavené na tmavé.
 */
export const isDarkTheme: Selector<IAppState, boolean> = (state) => getTheme(state) === ApplicationTheme.dark;

/**
 * Získá název druhého dostupného téma.
 */
export const getOtherTheme: Selector<IAppState, ApplicationTheme> = (state) => (
    isDarkTheme(state) ? ApplicationTheme.light : ApplicationTheme.dark
);
